// extracted by mini-css-extract-plugin
export default {"signUpForm":"SignUpFormComponent_signUpForm__gL2UA","registerButton":"SignUpFormComponent_registerButton__rFpk9","error":"SignUpFormComponent_error__+vRy1"};